<template>
  <div class="supplier-row">
    <div class="container supplier-row__container">
      <p class="supplier-row__text">
        We work with top UK business connectivity providers
      </p>
      <div class="supplier-row__suppliers">
        <div
          v-for="supplier of suppliers"
          :key="supplier.name"
          class="supplier-row__logo"
        >
          <img
            v-lazy="supplier.img"
            :alt="`${supplier.name} logo`"
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SupplierRow',
  data () {
    return {
      suppliers: [
        {
          name: 'Plusnet',
          img: require('@/assets/logos/suppliers/plusnet/black.svg')
        },
        {
          name: 'Daisy',
          img: require('@/assets/logos/suppliers/daisy/black.svg')
        },
        {
          name: 'BT Business',
          img: require('@/assets/logos/suppliers/bt/black.svg')
        },
        {
          name: 'Focus',
          img: require('@/assets/logos/suppliers/focus/black.svg')
        },
        {
          name: 'TalkTalk',
          img: require('@/assets/logos/suppliers/talktalk/black.svg')
        },
        {
          name: 'EE',
          img: require('@/assets/logos/suppliers/ee/black.svg')
        }
      ]
    }
  }
}
</script>

<style lang="scss">
.supplier-row {
  min-height: 129px;
  padding: $spacing-40 $spacing-0;
  background-color: $supplier-bg;

  &__container {
    display: flex;
    align-items: center;
  }

  &__text {
    max-width: 300px;
    margin: $spacing-0;
    font-weight: 500;
    text-align: left;
    font-size: 18px;
    line-height: 24px;
  }

  &__suppliers {
    display: flex;
    flex-grow: 1;
    justify-content: space-between;
    padding-left: $spacing-12;
  }

  &__logo img {
    width: 100%;
    height: 100%;
  }

  @media (max-width: $screen-lg) {
    padding: $spacing-16 $spacing-0;

    &__container {
      flex-direction: column;
    }

    &__text {
      margin-bottom: $spacing-16;
      text-align: center;
    }

    &__suppliers {
      width: 100%;
      justify-content: center;
      flex-wrap: wrap;
      padding-left: $spacing-0;
    }

    &__logo {
      max-width: 33%;
      height: 50px;
      margin: $spacing-16 $spacing-12 $spacing-0;
    }
  }

  @media (max-width: $screen-md) {

    &__logo {
      max-width: 28%;
      height: 50px;
      margin: $spacing-16 $spacing-8 $spacing-0;
    }

    &__suppliers {
      justify-content: space-around;
      max-width: 420px;
     }
  }
}
</style>
